import React from 'react';
import { motion } from 'framer-motion';
type Tone = 'accent' | 'bright' | 'positive' | 'danger';
const strokes: Record<Tone, string> = {
  accent: 'stroke-accent',
  bright: 'stroke-bright',
  positive: 'stroke-positive',
  danger: 'stroke-danger'
};
const fills: Record<Tone, string> = {
  accent: 'fill-accent',
  bright: 'fill-bright',
  positive: 'fill-positive',
  danger: 'fill-danger'
};
interface SparklineProps {
  data: number[];
  tone?: Tone;
  width?: number;
  height?: number;
}
export function Sparkline({
  data,
  tone = 'accent',
  width = 88,
  height = 28
}: SparklineProps) {
  if (data.length < 2) return null;
  const max = Math.max(...data);
  const min = Math.min(...data);
  const span = max - min || 1;
  const pts = data.map((v, i) => [i / (data.length - 1) * (width - 6) + 3, height - 3 - (v - min) / span * (height - 6)]);
  const d = pts.map(([x, y], i) => `${i ? 'L' : 'M'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const [lx, ly] = pts[pts.length - 1];
  return <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden className="overflow-visible" data-id="element-144" data-mp="2qly7yi125rql">
      <motion.path key={d} d={d} fill="none" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" className={strokes[tone]} initial={{
      pathLength: 0,
      opacity: 0
    }} animate={{
      pathLength: 1,
      opacity: 1
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-145" data-mp="2llk133b70nu5" />
      <circle cx={lx} cy={ly} r={2.25} className={fills[tone]} data-id="element-146" data-mp="35aucw67tiomz" />
    </svg>;
}